import React from "react";
import FinDocListPage from "../components/FinDocListPage";
import { queryFinDoc } from "../newApi/findoc.api";

export default function FinDocHistory() {
  return (
    <FinDocListPage
      title="歷史紀錄"
      menuKey="FinDocHistory"
      defaultStatuses={["done", "reject", "cancel"]}
      fetcher={queryFinDoc}
      getActions={(record, actor, navigate) => [
        {
          label: "檢視",
          onClick: () => navigate(`/FinDoc/View/${record.findoc_no}`),
        },
      ]}
    />
  );
}